import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { getUploadPath } from '../../../utility/app.utility';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  @Input() logoFileName?: string = '';
  @Input() hStyleClass!: string;
  @Input() variant: 'base' | 'icon' = 'base';

  protected readonly getUploadPath = getUploadPath;
}
